import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { DashboardService } from "../_service/dashboard.service";
import { Button } from "./button.component";
import { Loader } from "./loader.component";
import announcementsIcon from "../_assets/images/announcement.png";
import profileIconImg from "../_assets/images/profile-img.png";
import mailImg from "../_assets/images/mail.png";
import messageImg from "../_assets/images/message.png";
import { OrganizationService } from "../_service/organization.service";
import { setOrganization } from "../_store/_actions/organization.actions";
import { AnnouncementService } from "../_service/announcement.service";
import moment from "moment";
import { FeedbackService } from "../_service/feedback.service";
import { TRACK_MANAGEMENT_ROUTE } from "../_pages/track-management.page";
import { TrackService } from "../_service/track.service";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { stateToHTML } from "draft-js-export-html";
import { convertFromRaw } from "draft-js";
import { SurveysService } from "../_service/surveys.service";
import { CREATE_SURVEY_ROUTE } from "../_pages/create-survey-page";
import {
  getSurveyDetailsRoute,
  SURVEY_DETAILS_ROUTE,
} from "../_pages/survey-details.page";
import surveyCheckIcon from "../_assets/images/survey-check.png";
import surveyCalendarIcon from "../_assets/images/survey-calendar.png";
import surveyIconImg from "../_assets/images/survey-icon.png";
import InfiniteScroll from "react-infinite-scroll-component";
import surveyRouteImage from "../_assets/images/survey.png";
import { SURVEY_ROUTE } from "../_pages/survey.page";
import { ENGAGEMENT_ANALYTICS_ROUTE } from "../_pages/engagement-analytics.page";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

let labels = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const OverviewAnalyticsCardComponent = ({
  addToast,
  organization,
  history,
  user,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAnnouncementLoading, setIsAnnouncementLoading] = useState(false);
  const [isTrackLoading, setIsTrackLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState();
  const [announcements, setAnnouncements] = useState([]);
  const [feebackData, setFeedbackData] = useState([]);
  const [trackData, setTrackData] = useState([]);
  const [isFeebackLoading, setIsFeebackLoading] = useState(false);
  const [showInfiniteScroll, setShowInfiniteScroll] = useState(false);
  const feebackLabels = {
    workLifeBalance: "Work-life Balance",
    myPatientInteractions: "My Patient Interactions",
    mySafetyAndWellbeing: "My Safety & Wellbeing",
    dailyFrustrations: "Daily Frustrations",
    coWorkerRelashionships: "Co-worker relationships",
  };
  // survey state is to show survey list in dashobard survey widget
  const [surveys, setSurveys] = useState([]);
  const [isSurveyLoading, setIsSurveyLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreRecords, setHasMoreRecords] = useState(true);

  useEffect(() => {
    getDashboardData();
  }, [user]);

  // useEffect(() => {
  //   if (user.role === "superAdmin" && organization) {
  //     getTracksData(organization);
  //   }
  // }, [organization]);

  const getDashboardData = () => {
    setIsLoading(true);
    if (user.role === "superAdmin") {
      DashboardService.getDashboardData(user)
        .then((resp) => {
          setIsLoading(false);
          setDashboardData(resp);
        })
        .catch((error) => {
          setIsLoading(false);
          if (error && error.response && error.response.data.message) {
            addToast(error.response.data.message, "", ToastTypes.danger);
          }
        });
    }
    if (user.role === "orgAdmin") {
      getOrgDashboardData();
      getFeedbackData();
    }
    getAnnouncements();
    getSurveysData();
  };

  const getOrgDashboardData = () => {
    DashboardService.getOrgAdminDashboardData(user)
      .then((resp) => {
        setIsLoading(false);
        setDashboardData(resp);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const getAnnouncements = () => {
    setIsAnnouncementLoading(true);
    AnnouncementService.getAllAnnouncements(user)
      .then((resp) => {
        setIsAnnouncementLoading(false);
        setAnnouncements(resp);
      })
      .catch((error) => {
        setIsAnnouncementLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const getFeedbackData = () => {
    setIsFeebackLoading(true);
    FeedbackService.getFeedbacks(user)
      .then((resp) => {
        setIsFeebackLoading(false);
        setFeedbackData(resp);
      })
      .catch((error) => {
        setIsFeebackLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const getTracksData = () => {
    setIsTrackLoading(true);
    TrackService.getAllTracks(user)
      .then((resp) => {
        setIsTrackLoading(false);
        setTrackData(resp);
      })
      .catch((error) => {
        setIsTrackLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const convertCommentFromJSONToHTML = (text) => {
    return stateToHTML(convertFromRaw(JSON.parse(text)));
  };

  const getSurveysData = () => {
    setIsSurveyLoading(true);
    SurveysService.getSurveys(user, {
      page: currentPage,
    })
      .then((resp) => {
        setIsSurveyLoading(false);
        setCurrentPage(currentPage + 1);
        if (resp.survey.length >= 1) {
          setCurrentPage(currentPage + 1);
        } else {
          setHasMoreRecords(false);
        }
        setSurveys([...surveys, ...resp.survey]);
      })
      .catch((error) => {
        setIsSurveyLoading(false);
        console.log(error);
      });
  };

  const fetchMoreData = () => {
    setShowInfiniteScroll(true);
    SurveysService.getSurveys(user, {
      page: currentPage,
    })
      .then((resp) => {
        if (resp.survey.length >= 1) {
          setCurrentPage(currentPage + 1);
        } else {
          setHasMoreRecords(false);
        }
        setShowInfiniteScroll(false);
        setSurveys([...surveys, ...resp.survey]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="flex">
      <div className="w-3/5">
        <div className="card rounded-md bg-white p-8">
          <div className="flex items-center">
            {user.role === "superAdmin" ? (
              <span className="font-bold text-xl text-primary">
                Overview Analytics
              </span>
            ) : (
              <></>
            )}
            {user.role === "orgAdmin" ? (
              <>
                <span className="font-bold text-xl text-primary">
                  Engagement Analytics
                </span>
                <img
                  src={surveyRouteImage}
                  className="ml-2 h-4 w-4 cursor-pointer"
                  onClick={() => history.push(ENGAGEMENT_ANALYTICS_ROUTE)}
                />
              </>
            ) : (
              <></>
            )}
          </div>
          {!isLoading ? (
            <div className="flex mt-5 dashboard-count-container">
              {user.role === "superAdmin" ? (
                <div className="pr-6">
                  <p className="text-base text-primary font-bold">
                    Total Users
                  </p>
                  <p className="text-base t-grey font-bold">
                    {dashboardData && dashboardData.userCount
                      ? dashboardData.userCount
                      : 0}{" "}
                    members
                  </p>
                </div>
              ) : (
                <></>
              )}
              {user.role === "orgAdmin" ? (
                <>
                  {/* <div className="pr-6">
                    <p className="text-base text-primary font-bold">Total Users</p>
                    <p className="text-base t-grey font-bold">
                      {dashboardData && dashboardData.userCount
                        ? dashboardData.userCount
                        : 0}{" "}
                      members
                    </p>
                  </div>
                  <div className="pl-6 pr-6 border-left">
                    <p className="text-base text-primary font-bold">
                      Total Tracks
                    </p>
                    <p className="text-base t-grey font-bold">
                      {dashboardData && dashboardData.trackCount
                        ? dashboardData.trackCount
                        : 0}{" "}
                      tracks
                    </p>
                  </div> */}

                  <div className="pr-3">
                    <p className="text-base text-primary font-bold">
                      Participants Signed-Up
                    </p>
                    <p className="text-base t-grey font-bold">
                      260/400 signed-up
                    </p>
                  </div>
                  <div className="pl-3 pr-3 border-left">
                    <p className="text-base text-primary font-bold">
                      Users this Month
                    </p>
                    <p className="text-base t-grey font-bold">198 users</p>
                  </div>
                  <div className="pl-3 pr-3 border-left">
                    <p className="text-base text-primary font-bold">
                      Meditations this Month
                    </p>
                    <p className="text-base t-grey font-bold">
                      233 Meditations
                    </p>
                  </div>
                  <div className="pl-3 pr-3 border-left">
                    <p className="text-base text-primary font-bold">
                      Latest Survey
                    </p>
                    <p className="text-base t-grey font-bold">
                      85/150 responded
                    </p>
                  </div>
                  <div className="pl-3 border-left">
                    <p className="text-base text-primary font-bold">
                      Coaching this Month
                    </p>
                    <p className="text-base t-grey font-bold">130 sessions</p>
                  </div>
                </>
              ) : (
                <></>
              )}
              {user.role === "superAdmin" ? (
                <div className="pl-6 border-left">
                  <p className="text-base text-primary font-bold">
                    Total Organizations
                  </p>
                  <p className="text-base t-grey font-bold">
                    {dashboardData && dashboardData.organizationCount
                      ? dashboardData.organizationCount
                      : 0}
                  </p>
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <Loader />
          )}
        </div>
        {user.role === "orgAdmin" ? (
          <div
            className="card rounded-md bg-white p-8 mt-4"
            style={{ minHeight: "45vh" }}>
            <div className="mb-3">
              <span className="font-bold text-xl text-primary">
                Average Wellbeing
              </span>
            </div>
            <div className="flex">
              <div style={{ width: "80%" }}>
                <Line
                  data={{
                    labels: labels,
                    datasets: [
                      {
                        label: "Dataset 1",
                        data: [10, 20, 30, 25, 30, 40, 25],
                        borderColor: "#576CD0",
                        backgroundColor: "#576CD0",
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                  }}
                />
              </div>
              <div className="text-left" style={{ width: "20%" }}>
                <div
                  className="border p-2 rounded-md"
                  style={{ background: "#F1F3FD" }}>
                  <div className="">
                    <span className="text-xs" style={{ color: "#434449" }}>
                      Data Summary
                    </span>
                  </div>
                  <div>
                    <div>
                      <span className="text-xs" style={{ color: "#434449" }}>
                        Average:{" "}
                      </span>
                      <span className="text-xs t-grey">25</span>
                    </div>
                    <div>
                      <span className="text-xs" style={{ color: "#434449" }}>
                        Total Entries:{" "}
                      </span>
                      <span className="text-xs t-grey">7</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {user.role === "orgAdmin" ? (
          <div className="card rounded-md bg-white py-3 px-9 mt-3 feedback-queue-container">
            <div className="">
              <span className="font-bold text-xl text-primary">
                Feedback Queue
              </span>
            </div>
            {!isFeebackLoading ? (
              <div className="flex flex-wrap my-3">
                {feebackData && feebackData.length > 0 ? (
                  feebackData.map((fd, index) => (
                    <div
                      className="mb-2 shadow p-2 px-4 rounded mr-3 shadow-sm feedback-border"
                      style={{
                        width: "200px",
                        border: "0.5px soild #00B3FE80",
                      }}
                      key={index}>
                      <div className="flex items-center justify-between">
                        <p className="w-1/2 t-grey">
                          {feebackLabels[fd.category]}
                        </p>
                        <p className="t-grey">{fd.count}</p>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className="text-primary">Feedback data not found</p>
                  </div>
                )}
              </div>
            ) : (
              <Loader />
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="flex-1 ml-5" style={{ width: "35%" }}>
        {/* Announcement Widget  START */}
        <div
          className="bg-white card px-4 py-4 rounded mb-4 overflow-hidden"
          style={{ maxHeight: "43vh" }}>
          <div className="flex items-center justify-between">
            <span className="font-bold text-xl text-primary">
              Announcements
            </span>
            <Button
              label="+ Create New"
              className="btn-primary rounded-xl"
              onClick={() => history.push("/announcement")}
            />
          </div>
          {!isAnnouncementLoading ? (
            <div
              className={`mt-4 ${
                announcements.length > 0 ? "overflow-y-auto" : ""
              }`}
              style={{ maxHeight: "32vh", minHeight: "32vh" }}>
              {announcements && announcements.length > 0 ? (
                announcements.map((an) => (
                  <div
                    className="flex px-4 py-4 rounded-md w-full bg-purple-100 mb-2"
                    style={{
                      backgroundColor: "#F6FAFF",
                      border: "1px solid #9BC4F8",
                    }}
                    key={an._id}>
                    <div>
                      <img src={announcementsIcon} />
                    </div>
                    <div className="w-full ml-3">
                      <div className="flex-1 w-full">
                        <div className="flex flex-1 items-center w-full">
                          <img src={profileIconImg} className="h-2.5" />
                          <div className="ml-2 flex justify-between w-full items-center">
                            <span className="text-sm t-grey font-bold w-56 overflow-y-auto whitespace-nowrap">
                              {an.displayName}
                            </span>
                            <ol className="list-disc p-0 t-grey">
                              <li className="text-xs">
                                {moment(an.created).fromNow()}
                              </li>
                            </ol>
                          </div>
                          {/* <span className="
                                text-xs t-grey"></span> */}
                        </div>
                      </div>
                      <div>
                        <div className="text-sm t-grey font-bold w-80 whitespace-nowrap overflow-y-auto">
                          {an.notificationTitle}
                        </div>
                      </div>
                      <div className="mt-2 overflow-y-auto h-8 w-80 overflow-x-hidden">
                        <span
                          className="text-xs t-grey"
                          dangerouslySetInnerHTML={{
                            __html:
                              JSON.parse(an.notificationBody).blocks[0].text
                                .length > 35 &&
                              !JSON.parse(
                                an.notificationBody
                              ).blocks[0].text.includes(" ")
                                ? `<span>${JSON.parse(
                                    an.notificationBody
                                  ).blocks[0].text.slice(0, 35)}</span>` + "..."
                                : convertCommentFromJSONToHTML(
                                    an.notificationBody
                                  ),
                          }}></span>
                      </div>
                      {/* <div className="flex w-full mt-2">
                          <div className="flex items-center mr-2">
                            <img src={messageImg} className="h-4" />
                            <span className="ml-2 t-grey text-xs">131 unread</span>
                          </div>
                          <div className="flex items-center">
                            <img src={mailImg} className="h-4" />
                            <span className="ml-2 t-grey text-xs">234 read</span>
                          </div>
                        </div> */}
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="text-primary">Announcement data not found</p>
                </div>
              )}
            </div>
          ) : (
            <div
              className="bg-white card px-4 py-4 rounded mb-4 overflow-hidden"
              style={{ minHeight: "43vh" }}>
              <Loader />
            </div>
          )}
        </div>
        {/* Announcement Widget  END */}

        {/* Track Management Widget START */}
        {/* <div
            className="bg-white card px-4 py-4 rounded overflow-hidden"
            style={{ maxHeight: "43vh" }}>
            <div className="flex items-center justify-between">
              <span className="font-bold text-lg text-primary">
                Track Management
              </span>
              <Button
                label="View All"
                className="btn-primary rounded-xl"
                onClick={() => history.push(TRACK_MANAGEMENT_ROUTE)}
              />
            </div>
            {!isTrackLoading ? (
              <div
                className={`mt-4 ${
                  trackData.length > 0 ? "overflow-y-auto" : ""
                }`}
                style={{ maxHeight: "32vh", minHeight: "32vh" }}>
                {trackData && trackData.length > 0 ? (
                  trackData.map((td) => (
                    <div
                      className="flex rounded-md w-full bg-purple-100 mb-2"
                      style={{
                        backgroundColor: "#F6FAFF",
                        border: "1px solid #9BC4F8",
                        minHeight: "100px",
                        maxHeight: "100px",
                      }}
                      key={td._id}>
                      <div className="w-2/5">
                        <img
                          src={td.imageURL}
                          className="max-h-full min-h-full rounded w-full"
                        />
                      </div>
                      <div className="px-3 py-2 w-full">
                        <div className="flex-1 w-full">
                          <div className="flex flex-1 items-center w-full">
                            <img
                              src={profileIconImg}
                              className="h-2.5 hidden"
                            />
                            <div className="flex justify-between w-full items-center">
                              <span className="text-sm t-grey font-bold lg:w-40 xl:w-48 2xl:w-72 whitespace-nowrap overflow-y-auto">
                                {td.title}
                              </span>
                              <ol className="list-none p-0 t-grey">
                                <li className="text-xs">{moment(td.created).fromNow()}</li>
                              </ol>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2 overflow-y-auto h-8 overflow-x-hidden">
                          <p className="text-xs t-grey">{td.description.length > 35 && !td.description.includes(' ') ? td.description.slice(0, 35) + ' ' + '...' : td.description }</p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className="text-primary">Tracks not found</p>
                  </div>
                )}
              </div>
            ) : (
              <div
                className="bg-white card px-4 py-4 rounded mb-4 overflow-hidden"
                style={{ minHeight: "43vh" }}>
                <Loader />
              </div>
            )}
          </div> */}
        {/* Track Management Widget  END*/}

        {/*  Survey Widget START */}
        <div
          className="bg-white card px-4 py-4 rounded overflow-hidden"
          style={{ maxHeight: "41vh" }}>
          <div className="flex items-center justify-between">
            <span className="font-bold text-xl text-primary flex items-center">
              Surveys
              <img
                src={surveyRouteImage}
                className="ml-2 h-4 w-4 cursor-pointer"
                onClick={() => history.push(SURVEY_ROUTE)}
              />
            </span>
            <Button
              label="+ Create New"
              className="btn-primary rounded-xl"
              onClick={() => history.push(CREATE_SURVEY_ROUTE)}
            />
          </div>
          {!isSurveyLoading ? (
            <div
              className={`mt-4`}
              style={{ maxHeight: "30vh", minHeight: "30vh" }}>
              <InfiniteScroll
                hasMore={hasMoreRecords}
                next={() => fetchMoreData()}
                loader={showInfiniteScroll ? <Loader /> : <></>}
                height="30vh"
                dataLength={surveys.length}>
                {surveys && surveys.length > 0 ? (
                  surveys.map((survey) => (
                    <div
                      className={`flex px-4 py-4 rounded-md w-full bg-purple-100 mb-2 cursor-pointer`}
                      style={{
                        backgroundColor: "#EEFCF1",
                        border: "1px solid #9FDFAD",
                      }}
                      key={survey._id}
                      onClick={() => {
                        history.push({
                          pathname: `/survey-details`,
                          search: `?surveyId=${survey._id}`,
                        });
                      }}>
                      <div className="w-1/12">
                        <img src={surveyIconImg} />
                      </div>
                      <div className="w-10/12 ml-3 ">
                        <div className="flex justify-between">
                          <div
                            className="text-sm t-grey font-bold whitespace-nowrap overflow-y-auto"
                            style={{ width: "65%" }}>
                            {survey.title}
                          </div>
                          <ol
                            className="list-disc p-0 t-grey pl-6 flex flex-row-reverse"
                            style={{ width: "35%" }}>
                            <li className="text-xs">
                              {moment(survey.createdAt).fromNow()}
                            </li>
                          </ol>
                        </div>
                        <div className="overflow-y-auto h-8 overflow-x-hidden flex items-center justify-between">
                          <div className="w-2/4 flex items-center">
                            <img
                              src={surveyCheckIcon}
                              className="survey-widget-img mr-1"
                            />
                            <span className="text-xs t-grey whitespace-nowrap overflow-y-auto w-10/12">
                              {` ${survey.submittedUser} `} /
                              {` ${survey.allUsers} `} Completed{" "}
                            </span>
                          </div>
                          <div className="w-2/4 text-right flex items-center justify-end">
                            <img
                              src={surveyCalendarIcon}
                              className="survey-widget-img mr-1"
                            />
                            <span className="text-xs t-grey whitespace-nowrap overflow-y-auto">
                              {`Due ${moment(survey.dueDate)
                                .utc()
                                .format("ddd MMMM DD")}`}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className="text-primary">Surveys data not found</p>
                  </div>
                )}
              </InfiniteScroll>
            </div>
          ) : (
            <div
              className="bg-white card px-4 py-4 rounded mb-4 overflow-hidden"
              style={{ minHeight: "47vh" }}>
              <Loader />
            </div>
          )}
        </div>
        {/*  Survey Widget END */}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth,
  organization: state.orgData,
});

// const DashboardPage = DashboardPageComponent;
const OverviewAnalyticsCard = withToast(
  connect(mapStateToProps)(OverviewAnalyticsCardComponent)
);

// export default DashboardPage;

export default OverviewAnalyticsCard;
